import React from 'react';
import './App.css';
import Routes from './route';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import { store, persist } from './redux/store';
import './css/custom.scss';
import { PersistGate } from 'redux-persist/integration/react';
import { createTheme, ThemeProvider } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const { palette } = createTheme();

  const theme = createTheme({
    palette: {
      primaryMAP: palette.augmentColor({ color: { main: '#82be2a', contrastText: '#fff' } })
    }
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persist}>
        <ThemeProvider theme={theme}>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_KEY}>
            <Routes />
          </GoogleOAuthProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
